import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import cn from 'classnames';
import { useState, useMemo } from 'react';
import { Icon } from '@fe/icons';
import { TextInput } from '@fe/textinput';
import createPasswordPolicy from 'password-sheriff';

var AuthHeader = function AuthHeader(_ref) {
  var logo = _ref.logo;
  return jsx("div", {
    className: "flex justify-center w-auto mx-auto h-12",
    children: jsx("img", {
      className: "h-10",
      src: logo,
      alt: "logo"
    })
  });
};

var PasswordFields = function PasswordFields(_ref) {
  var password = _ref.password,
    onPasswordChange = _ref.onPasswordChange,
    onVerifyPasswordChange = _ref.onVerifyPasswordChange;
  var _useState = useState(''),
    verifyPassword = _useState[0],
    setVerifyPassword = _useState[1];
  var passwordPolicy = useMemo(function () {
    return createPasswordPolicy('good');
  }, []);
  var _useState2 = useState({
      verified: false,
      lengthAtLeast: false,
      containsAtLeast: {
        lowerCase: false,
        numbers: false,
        specialCharacters: false,
        upperCase: false,
        verified: false
      }
    }),
    verifiedPasswordValidationRules = _useState2[0],
    setVerifiedPasswordValidationRules = _useState2[1];
  var handlePasswordChange = function handlePasswordChange(_, name, value) {
    var _result$rules$find, _containsAtLeastRules, _containsAtLeastRules2, _containsAtLeastRules3, _containsAtLeastRules4;
    var result = passwordPolicy.missing(value);
    onPasswordChange(value, result.verified);
    var containsAtLeastRules = result.rules.find(function (rule) {
      return rule.code === 'containsAtLeast';
    });
    setVerifiedPasswordValidationRules({
      verified: result.verified,
      lengthAtLeast: ((_result$rules$find = result.rules.find(function (rule) {
        return rule.code === 'lengthAtLeast';
      })) == null ? void 0 : _result$rules$find.verified) || false,
      containsAtLeast: {
        lowerCase: ((_containsAtLeastRules = containsAtLeastRules.items.find(function (rule) {
          return rule.code === 'lowerCase';
        })) == null ? void 0 : _containsAtLeastRules.verified) || false,
        numbers: ((_containsAtLeastRules2 = containsAtLeastRules.items.find(function (rule) {
          return rule.code === 'numbers';
        })) == null ? void 0 : _containsAtLeastRules2.verified) || false,
        specialCharacters: ((_containsAtLeastRules3 = containsAtLeastRules.items.find(function (rule) {
          return rule.code === 'specialCharacters';
        })) == null ? void 0 : _containsAtLeastRules3.verified) || false,
        upperCase: ((_containsAtLeastRules4 = containsAtLeastRules.items.find(function (rule) {
          return rule.code === 'upperCase';
        })) == null ? void 0 : _containsAtLeastRules4.verified) || false,
        verified: containsAtLeastRules.verified
      }
    });
  };
  var handleVerifyPasswordChange = function handleVerifyPasswordChange(_, name, value) {
    setVerifyPassword(value);
    onVerifyPasswordChange(password === value);
  };
  return jsxs(Fragment, {
    children: [jsxs("div", {
      children: [jsxs("div", {
        className: "flex items-end",
        children: [jsx(TextInput, {
          type: "password",
          rootClassName: "w-full",
          className: "pr-10",
          label: "New Password",
          name: "password",
          required: true,
          value: password,
          onChange: handlePasswordChange
        }), verifiedPasswordValidationRules.verified && jsx(Icon, {
          name: "CircleCheck",
          className: "text-green-500 -ml-7 mb-2 z-10"
        })]
      }), jsxs("div", {
        children: [jsx("p", {
          className: "mt-1 text-sm text-grey-davys-500",
          children: "Password must:"
        }), jsxs("div", {
          className: "flex mt-2 text-sm text-grey-davys-200",
          children: [jsx(Icon, {
            name: verifiedPasswordValidationRules.lengthAtLeast ? 'CircleCheck' : 'InformationCircle',
            className: cn('mr-1', {
              'text-green-500': verifiedPasswordValidationRules.lengthAtLeast
            })
          }), jsxs("p", {
            children: ["Be at least", jsx("span", {
              className: cn({
                'text-green-500': verifiedPasswordValidationRules.lengthAtLeast
              }),
              children: "\xA08 characters long."
            })]
          })]
        }), jsxs("div", {
          className: "flex mt-2 text-sm text-grey-davys-200",
          children: [jsx(Icon, {
            name: verifiedPasswordValidationRules.containsAtLeast.verified ? 'CircleCheck' : 'InformationCircle',
            className: cn('mr-1', {
              'text-green-500': verifiedPasswordValidationRules.containsAtLeast.verified
            })
          }), jsx("div", {
            className: "flex-1",
            children: jsxs("p", {
              children: ["Include at least 3 of the following 4 types of characters:", jsx("span", {
                className: cn({
                  'text-green-500': verifiedPasswordValidationRules.containsAtLeast.lowerCase
                }),
                children: "\xA0a lower-case letter"
              }), ",", jsx("span", {
                className: cn({
                  'text-green-500': verifiedPasswordValidationRules.containsAtLeast.upperCase
                }),
                children: "\xA0an upper-case letter"
              }), ",", jsx("span", {
                className: cn({
                  'text-green-500': verifiedPasswordValidationRules.containsAtLeast.numbers
                }),
                children: "\xA0a number"
              }), ",", jsx("span", {
                className: cn({
                  'text-green-500': verifiedPasswordValidationRules.containsAtLeast.specialCharacters
                }),
                children: "\xA0a special character (i.e: !@#$)."
              })]
            })
          })]
        })]
      })]
    }), jsxs("div", {
      className: "flex items-end",
      children: [jsx(TextInput, {
        type: "password",
        rootClassName: "w-full",
        className: "pr-10",
        label: "Retype Password",
        name: "confirmPassword",
        required: true,
        onChange: handleVerifyPasswordChange,
        value: verifyPassword
      }), verifyPassword && verifyPassword === password && jsx(Icon, {
        name: "CircleCheck",
        className: "text-green-500 -ml-7 mb-2 z-10"
      })]
    })]
  });
};

export { AuthHeader, PasswordFields };
//# sourceMappingURL=components.esm.js.map
